import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthUtil } from '../util/auth-util';
import { SuiteLanguage } from '../model/suite-language';
import { LanguageBase } from '../envelope/model/language';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CookieWrapperService {
  languageBase: LanguageBase;

  constructor(
    private cookieService: CookieService,
    private translateService: TranslateService) {
    this.languageBase = new LanguageBase(translateService);
  }

  getJwtToken(): string {
    return this.cookieService.get(AuthUtil.AUTH_SUITE_JWT_TOKEN);
  }

  getSuiteLanguage(): SuiteLanguage {
    const language = this.cookieService.get(AuthUtil.SUITE_LANGUAGE);
    if (language) {
      const suiteLanguage = { language: language.substring(0, 2) };
      return suiteLanguage;
    }
    return null;
  }

  public setSuiteLanguage(lang: string) {
    this.cookieService.set(AuthUtil.SUITE_LANGUAGE, this.languageBase.getType(lang), null, '/');
  }
}
